import {
  LayoutDashboard,
  Key,
  User,
  Mic,
  Video,
  Image,
  FileText,
  Receipt,
  ShieldCheck
} from 'lucide-react';

export const menuItems = [
  { id: 'dashboard', icon: LayoutDashboard, text: '首页', path: '/dashboard' },
  { id: 'api-keys', icon: Key, text: '管理API密钥', path: '/api-keys' },
  { id: 'avatars', icon: User, text: '我的数字人', path: '/my-avatars' },
  { id: 'voice-clone', icon: Mic, text: '我的声音', path: '/voice-cloning' },
  { id: 'generate-video', icon: Video, text: '生成视频', path: '/generate-video' },
  { id: 'my-videos', icon: Video, text: '我的视频', path: '/my-videos' },
  { id: 'generate-image', icon: Image, text: '生成图片', path: '/generate-image' },
  { id: 'my-images', icon: Image, text: '我的图片', path: '/my-images' },
  { id: 'workflow-results', icon: FileText, text: '工作流结果', path: '/workflow-results' },
  { id: 'bills', icon: Receipt, text: '账单明细', path: '/bills' },
  { id: 'subscription-admin', icon: ShieldCheck, text: '订阅管理', path: '/subscription-admin', adminOnly: true },
];